export class MakePasswordPrivateRequest {
    encryptedPasswordKey: string;
    gid: number;
}